import { render, staticRenderFns } from "./DashboardDesktopGrid.vue?vue&type=template&id=36baaff7&"
import script from "./DashboardDesktopGrid.vue?vue&type=script&lang=ts&"
export * from "./DashboardDesktopGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports